import {Component, EventEmitter, Input, Output, ViewChild, ViewContainerRef, ChangeDetectionStrategy} from '@angular/core';
import { FwcModalSlide } from '../../../fwc-lib.js';
import { cloneDeep } from 'lodash';


// DO NOT USE THIS COMPONENT - I NEED TO REBUILD AS A SERVICE - SHANNON
// TODO: REBUILD AS SERVICE. CURRENT IMPLEMENTATION DOES NOT SUPPORT MULTIPLE INSTANCES

@Component({
    selector: 'sae-modal-slide',
    template: `<fwc-modal-slide [id]="fwcModalSlideId" direction="right" lock-scroll="true" caller-id="openSlideModal" label-aria-modal-header="Slide In Modal Header" (fwc-modal-close)="closeModal($event)"></fwc-modal-slide>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalSlideComponent {
  @Input() header: string;
  @Input() cancelBtn: string;
  @Input() continueBtn: string;
  @Input() fwcModalSlideId: any;
  @Input() templateId: any;
  @Input() containerId: any;
  modal: any;
  @Output() cancelClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() continueClick: EventEmitter<any> = new EventEmitter<any>();


  constructor() {
  }

  openModal(): void {
    const fwcModalSlide = new FwcModalSlide();
    fwcModalSlide.build();
    this.modal = document.getElementById(this.fwcModalSlideId);
    if (this.modal.hasChildNodes()) {
      this.modal.removeChild(this.modal.firstChild);
    }
    const modalContent = document.getElementById(this.templateId);
    this.modal.appendChild(modalContent);
    this.modal.setAttribute('open', '');
  }
  closeModal(e): void {
    this.cancelClick.emit(true);
  }

}
